import { createSlice } from '@reduxjs/toolkit';
import { fetchCategoryProgram } from './Utils/CategoryProgramUtils';


const initialState = {
  filters: {
    'filter[id]': '',
    'filter[title]': '',
    'filter[is_parent]': '',
    'sort': '',
    'page': '',
  },
  data: [],
  isLoading: false,
};

const CategoryProgramSlice = createSlice({
  name: 'CategoryProgram',
  initialState: initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },

  },
  extraReducers: (builder) => { // Handle  action creators from createAsyncThunk
    builder
      .addCase(fetchCategoryProgram.pending, (state) => {
        // Handle loading state
        state.isLoading = true;
      })
      .addCase(fetchCategoryProgram.fulfilled, (state, action) => {
        // Handle success state
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchCategoryProgram.rejected, (state, action) => {
        // Handle error state
        console.log('rejected', action.error);
        state.isLoading = false;
      });
  }
});

export const { setFilters, setData } = CategoryProgramSlice.actions;

export default CategoryProgramSlice.reducer;
